export function TrainingDataPanel() {
  return (
    <div className="flex flex-col gap-3 px-1 pb-6">
      <div>
        <h2 className="text-[14px] font-semibold text-[var(--color-fg)]">Training data</h2>
        <p className="mt-0.5 text-[11px] text-[var(--color-fg-dim)]">Coming soon</p>
      </div>
      <div
        className="rounded-lg border border-[var(--color-border-subtle)] px-4 py-8 text-center"
        style={{ background: "var(--color-fill)" }}
      >
        <p className="text-[13px] text-[var(--color-fg-dim)]">This section is being built.</p>
      </div>
    </div>
  );
}
